






































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import moment from "moment";
import _ from "lodash";
import qs from "qs";
import MyCommon from "@/mixins/common";

import OperationHistory from "@/components/operationhistory.vue";
import vueSeamless from "@/components/vue-seamless-scroll/components/myClass.vue";
import Agreement from "./components/agreement.vue";
import OnlineSetting from "./components/onlinesetting.vue";
import Base from "./components/base.vue";
import Detail from "./components/detail.vue";
import License from "./components/license.vue";
import Description from "./components/description.vue";
import Tags from "./components/tags.vue";
import Grounds from "./components/grounds.vue";
import Price from "./components/price.vue";
import PriceExtend from "./components/price_extend.vue";
import Thumbnails from "./components/thumbnails.vue";
import ClosureTime from "./components/closure_time.vue";
import Report from "./components/report.vue";
import MonthExpense from "./components/month_expense.vue";
import Users from "./components/users_modal.vue";
import Vips from "./components/vips_modal.vue";
import UserPlayer from "./components/user_player_modal.vue";

import Clubs from "./components/clubs.vue";
import Blocks from "./components/blocks_modal.vue";
import AuthorizeUser from "./components/authuser.vue";
import Settlement from "./components/settlement.vue";
import Train from "./components/train.vue";

import Bill from "./components/bill.vue";
import Playrecord from "./components/playrecord.vue";
import Money from "./components/money.vue";
import CustomAudioPlay from "./components/broadcast.vue";

import EquipLogs from "./components/equiplogs.vue";
import OpenClose from "./components/openclose.vue";
import Powerfailure from "./components/powerfailure.vue";

import Camera from "./components/camera.vue";
import Door from "./components/door.vue";
import AnalysisReport from "./components/analysis_report.vue";

import Role from "./role.vue";
import Account from "./account.vue";
import ManageRecord from "./manage_record.vue";
import Notes from "./notes.vue";
import Ground from "./ground.vue";

import EquipmentControl from "./equipment_control.vue";

import SummaryBusiness from "./components/summary_business.vue";

import GroundLights from "./ailocal/groundlights.vue";
import StreetLights from "./ailocal/streetlights.vue";
import TimeSaleSetting from "./components/time_sale_setting.vue";

import GroundCalendar from "./ground_calendar.vue";

import TodayBuy from "./home/today_buy.vue";
import TodayPlay from "./home/today_play.vue";
import TodayGround from "./home/today_ground.vue";

import ResearchReportEdit from "./research_report_edit.vue";

import BpSubmitDetail from "./bp-submit-detail.vue";

import Setting1 from "./components/setting1.vue";
import Setting2 from "./components/setting2.vue";

import SaleCounter from "./components/sale_counter.vue";

import Product from "./product.vue";
import TsUpload from '@/components/upload.vue';

@Component({
  components: {
    TsUpload,
    SaleCounter,
    Product,
    ResearchReportEdit,
    Agreement,
    SummaryBusiness,
    OnlineSetting,
    OperationHistory,
    Base,
    Detail,
    License,
    Description,
    Tags,
    Grounds,
    Ground,
    Bill,
    Playrecord,
    Money,
    Price,
    PriceExtend,
    Thumbnails,
    ClosureTime,
    Report,
    MonthExpense,
    Users,
    Vips,
    UserPlayer,
    Clubs,
    Blocks,
    Role,
    Account,
    ManageRecord,
    vueSeamless,
    AuthorizeUser,
    Settlement,
    Notes,
    EquipmentControl,
    Train,
    CustomAudioPlay,
    EquipLogs,
    OpenClose,
    Powerfailure,
    Camera,
    Door,
    AnalysisReport,
    GroundLights,
    StreetLights,
    TimeSaleSetting,
    GroundCalendar,
    TodayBuy,
    TodayPlay,
    TodayGround,
    BpSubmitDetail,
    Setting1,
    Setting2
  }
})
export default class extends Mixins(MyCommon) {
  dmarketingModalVisible = false;

  dmarketingType = 0;

  billModalVisible = false;

  billModalTitle = "订单";

  billModalParams: any = {};

  vipModalVisible = false;

  userModalVisible = false;

  userPlayerModalVisible = false;

  clubModalVisible = false;

  groundModalVisible = false;

  blockModalVisible = false;

  authuserModalVisible = false;

  accountModalVisible = false;

  trainModalVisible = false;

  playrecordModalVisible = false;

  moneyModalVisible = false;

  managerecordModalVisible = false;

  managerecordModalTitle = "工作记录";

  managerecordModalParams: any = {};

  broadcastModalVisible = false;

  equiplogsModalVisible = false;

  opencloseModalVisible = false;

  powerfailureModalVisible = false;

  cameraModalVisible = false;

  doorModalVisible = false;

  analysisReportModalVisible = false;

  groundLightsModalVisible = false;

  streetLightsModalVisible = false;

  is_internal = false;

  is_wechat_stadium = false;

  is_limit_ai = false;
  is_ai_stadium=false;
  uploadpercent = 0;

  stadiumId = 0;

  classOption: any = {
    direction: 2,
    step: 3
  };

  grounds: any[] = [];

  stadium: any = {};

  total: any = {
    ccount1: 0,
    ccount2: 0,
    ccount3: 0,
    ccount4: 0,
    ccount5: 0
  };

  ai: any = {
    ccount1: 0,
    ccount2: 0,
    ccount3: 0,
    ccount4: 0,
    ccount5: 0,
    ccount6: 0
  };

  bill: any = {
    dayTotal: 0,
    dayCancel: 0,
    monthTotal: 0,
    monthCancel: 0
  };

  vip: any = {
    total: 0,
    monthTotal: 0,
    money: 0
  };

  block: any = {
    total: 0,
    cancel:0
  };

  train: any = {
    num: 0,
    student_num: 0,
    publish_num: 0
  };

  bindWire: any = {
    month_count: 0,
    today_count: 0
  };

  account: any = {
    num: 0
  };

  thumbnail = "/assets/cameras/3.jpg";

  url = "";

  accessToken = "";

  cameras: any[] = [];

  activeTab = "key1";

  calendarModalVisible = false;

  saleCounterModalVisible = false;

  productModalVisible = false;

  async handleChange(file:any){
    console.log('upload file',file)
    const res=await this.$store.dispatch('stadium/miniprogramqrcode', {
      stadium_id: this.stadiumId,
      qrcode:file,
    });
    if (res && res.Message && res.Message === 'success') {
      this.$message.success('上传成功');
    } else {
      this.$message.error(res.Message);
    }
  }

  deleteWxa(){
    this.$confirm({
      title: '确认信息',
      content: '确定要清除小程序二维码吗？',
      onOk: async () => {
        const res=await this.$store.dispatch('stadium/miniprogramqrcode', {
          stadium_id: this.stadiumId,
          qrcode:this.stadium.report_weapp_url,
          op:'clean',
        });
        if (res && res.Message && res.Message === 'success') {
          this.stadium.report_weapp_url='';
          this.stadium.report_weapp_qrcode='/assets/noimage.png';
          this.$message.success(res.Message);
          // this.loadData1()
        } else {
          this.$message.error(res.Message);
        }
      },
    })
  }

  showCalendarModal() {
    this.calendarModalVisible = true;
  }

  hideCalendarModal() {
    this.calendarModalVisible = false;
  }

  showSaleCounterModal() {
    this.saleCounterModalVisible = true;
  }

  hideSaleCounterModal() {
    this.saleCounterModalVisible = false;
  }

  showProductModal() {
    this.productModalVisible = true;
  }

  hideProductModal() {
    this.productModalVisible = false;
  }

  tabChange(e: any) {
    // console.log(e);
    this.activeTab = e;
    this.$router
      .push(
        `${this.$route.path}?${qs.stringify(
          {
            id: this.stadiumId,
            action: e
          },
          { arrayFormat: "brackets" }
        )}`
      )
      .catch(err => {
        // nothing to do
      });
  }

  updateOnlineReadTime(time: string) {
    this.stadium.online_read_time = time;
  }

  showBillModal(modalTitle: string, params: any = {}) {
    this.billModalTitle = modalTitle;
    this.billModalParams = params;
    this.billModalVisible = true;
  }

  hideBillModal() {
    this.billModalVisible = false;
  }

  showVipModal() {
    this.vipModalVisible = true;
  }

  hideVipModal() {
    this.vipModalVisible = false;
  }

  showUserModal() {
    this.userModalVisible = true;
  }

  hideUserModal() {
    this.userModalVisible = false;
  }

  showUserPlayerModal() {
    this.userPlayerModalVisible = true;
  }

  hideUserPlayerModal() {
    this.userPlayerModalVisible = false;
  }

  showClubModal() {
    this.clubModalVisible = true;
  }

  hideClubModal() {
    this.clubModalVisible = false;
  }

  showGroundModal() {
    this.groundModalVisible = true;
  }

  hideGroundModal() {
    this.loadGrounds();
    this.groundModalVisible = false;
  }

  showBlockModal() {
    this.blockModalVisible = true;
  }

  hideBlockModal() {
    this.blockModalVisible = false;
  }

  showAuthuserModal() {
    this.authuserModalVisible = true;
  }

  hideAuthuserModal() {
    this.authuserModalVisible = false;
  }

  showAccountModal() {
    this.accountModalVisible = true;
  }

  hideAccountModal() {
    this.accountModalVisible = false;
  }

  showTrainModal() {
    this.trainModalVisible = true;
  }

  hideTrainModal() {
    this.trainModalVisible = false;
  }

  showPlayrecordModal() {
    this.playrecordModalVisible = true;
  }

  hidePlayrecordModal() {
    this.playrecordModalVisible = false;
  }

  showMoneyModal() {
    this.moneyModalVisible = true;
  }

  hideMoneyModal() {
    this.moneyModalVisible = false;
  }

  showManageRecordModal(modalTitle: string, params: any = {}) {
    this.managerecordModalTitle = modalTitle;
    this.managerecordModalParams = params;
    this.managerecordModalVisible = true;
  }

  hideManageRecordModal() {
    this.managerecordModalVisible = false;
  }

  showBroadcastModal() {
    this.broadcastModalVisible = true;
  }

  hideBroadcastModal() {
    this.broadcastModalVisible = false;
  }

  showEquipLogsModal() {
    this.equiplogsModalVisible = true;
  }

  hideEquipLogsModal() {
    this.equiplogsModalVisible = false;
  }

  showOpencloseModal() {
    this.opencloseModalVisible = true;
  }

  hideOpencloseModal() {
    this.opencloseModalVisible = false;
  }

  showPowerfailureModal() {
    this.powerfailureModalVisible = true;
  }

  hidePowerfailureModal() {
    this.powerfailureModalVisible = false;
  }

  showCameraModal() {
    this.cameraModalVisible = true;
  }

  hideCameraModal() {
    this.cameraModalVisible = false;
  }

  showDoorModal() {
    this.doorModalVisible = true;
  }

  hideDoorModal() {
    this.doorModalVisible = false;
  }

  showAnalysisReportModal() {
    this.analysisReportModalVisible = true;
  }

  hideAnalysisReportModal() {
    this.analysisReportModalVisible = false;
  }

  showPlayerModal(name: string, thumbnail: string, url: string) {
    // url += "?begin=20211220130000&end=20211220140000";
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const d = window.dialog({
      title: `${name}的监控`,
      url: `/player.html?url=${url}&thumbnail=${thumbnail}&accessToken=${this.accessToken}`,
      zIndex: 2147483647
    });
    // console.log(d)
    d.show();
  }

  showManageRuleModal() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const d = window.dialog({
      width: 1000,
      height: 600,
      title: "管理规则",
      // url: 'https://www.taisam.cn/agreements/1.4/stadium_ai_manage_rule.html',
      content:
        '<iframe width="100%" height="100%" frameborder="0" scrolling="yes" src="https://www.taisam.cn/agreements/1.4/stadium_ai_manage_rule.html"></iframe>',
      zIndex: 2147483647
    });
    d.show();
  }

  showGroundLightsModal() {
    this.groundLightsModalVisible = true;
  }

  hideGroundLightsModal() {
    this.groundLightsModalVisible = false;
  }

  showStreetLightsModal() {
    this.streetLightsModalVisible = true;
  }

  hideStreetLightsModal() {
    this.streetLightsModalVisible = false;
  }

  renderDate1(date: string) {
    // 未申请，升级中，待升级
    if (date) {
      const days = moment().diff(moment(date), "days");
      return days;
    }

    return "0";
  }

  async loadGrounds() {
    const res = await this.$store.dispatch("stadium/getStadiumGrounds", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data && res.Data !== "{}") {
      this.grounds = res.Data;
    }
  }

  async loadStadiumDetail() {
    const res = await this.$store.dispatch("datav/stadiumDetail", {
      stadium_id: this.stadiumId
    });
    // console.log(res)
    if (res && res.Data) {
      this.stadium = res.Data;
      console.log("__stadium__", this.stadium.is_internal, this.stadium.is_wechat_stadium);
      this.is_internal = this.stadium.is_internal > 0;
      this.is_wechat_stadium = this.stadium.is_wechat_stadium > 0;
      this.is_limit_ai = (this.stadium.is_limit_ai || 0) > 0;
    }

    const res2 = await this.$store.dispatch("datav/stadiumTotal", {
      stadium_id: this.stadiumId
    });
    if (res2 && res2.Data) {
      this.total = {
        ccount1: parseInt(res2.Data.ccount1, 10),
        ccount2: parseInt(res2.Data.ccount2, 10),
        ccount3: parseInt(res2.Data.ccount3, 10),
        ccount4: parseInt(res2.Data.ccount4, 10),
        ccount5: parseInt(res2.Data.ccount5, 10),
        user_count: parseInt(res2.Data.user_count, 10)
      };
    }
    const res3 = await this.$store.dispatch("datav/stadiumAI", {
      stadium_id: this.stadiumId
    });
    if (res3 && res3.Data) {
      this.ai = {
        ccount1:
          parseInt(res3.Data.ccount3, 10) +
          parseInt(res3.Data.ccount4, 10) +
          parseInt(res3.Data.ccount6, 10),
        ccount2: parseInt(res3.Data.ccount2, 10),
        ccount3: parseInt(res3.Data.ccount3, 10),
        ccount4: parseInt(res3.Data.ccount4, 10),
        ccount5: parseInt(res3.Data.ccount5, 10),
        ccount6: parseInt(res3.Data.ccount6, 10)
      };
    }

    const res4 = await this.$store.dispatch("datav/stadiumCamera", {
      stadium_id: this.stadiumId
    });
    if (res4 && res4.Data) {
      this.cameras = res4.Data.lists;
      this.accessToken = res4.Data.access_token;
    }

    // 加载
  }

  // 加载订单管理统计
  async loadBillStatistics() {
    const res = await this.$store.dispatch("datav/statBill", {
      stadium_id: this.stadiumId
    });

    if (res && res.Data && res.Data !== "{}") {
      this.bill = {
        dayTotal: Number(res.Data.ccount1),
        dayCancel: Number(res.Data.ccount2),
        monthTotal: Number(res.Data.ccount3),
        monthCancel: Number(res.Data.ccount4)
      };
    }
  }

  async loadBlockStatistics() {
    const res = await this.$store.dispatch("datav/statBlock", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data && res.Data !== "{}") {
      this.block = {
        total: Number(res.Data.ccount1),
        cancel:Number(res.Data.cancelcount||0),
      };
    }
  }

  async loadTrainStatistics() {
    const res = await this.$store.dispatch("datav/statTrain", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data && res.Data !== "{}") {
      this.train = {
        num: Number(res.Data.ccount1),
        student_num: Number(res.Data.ccount2),
        publish_num: Number(res.Data.ccount3)
      };
    }
  }

  async loadBindWireStatistics() {
    const res = await this.$store.dispatch("datav/statBindWire", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data && res.Data !== "{}") {
      this.bindWire = {
        month_count: Number(res.Data.month_count),
        today_count: Number(res.Data.today_count)
      };
    }
  }

  async loadAccountStatistics() {
    const res = await this.$store.dispatch("datav/statAccount", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data && res.Data !== "{}") {
      this.account = {
        num: Number(res.Data)
      };
    }
  }

  updateMaterial(field: string) {
    let msg = "";
    switch (field) {
      case "report_path_ai":
        msg = "智能场馆正式营业海报";
        break;
      case "report_path_online":
        msg = "场馆上线海报";
        break;
      case "report_down_qrcode":
        msg = "球友端专用订场二维码（电子）";
        break;
      case "report_print_qrcode":
        msg = "球友端专用订场二维码（物料）";
        break;
      case "report_roll_screen":
        msg = "球友端订场App宣传资料";
        break;
      case "miniprogram_qrcode":
        msg = "小程序二维码";
        break;
      default:
    }
    this.$confirm({
      title: "确认消息",
      content: `确定更新${msg}吗？`,
      onOk: async () => {
        const res = await this.$store.dispatch(`stadium/${field.replace(/_/g, "")}`, {
          stadium_id: this.stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          _.set(this, [field], res.Data);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  async addrank() {
    this.$confirm({
      title: "确认信息",
      content: "确定要刷新场馆的城市排名吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/addrank", {
          stadium_id: this.stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  async mounted() {
    // console.log(this.$route);
    this.spinLoading = true;
    const query = { ...this.$route.query };
    // console.log(query)
    this.stadiumId = Number(query.id);

    if (query.action) {
      this.activeTab = String(query.action);
    }

    await this.loadStadiumDetail();
    this.loadBillStatistics();

    this.loadBlockStatistics();
    this.loadTrainStatistics();
    this.loadAccountStatistics();

    this.loadGrounds();
    this.spinLoading = false;
  }
}
